/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";






const Goto = (props) => {
    const _meetingID = (props.match.params.MeetingID !== undefined) ? props.match.params.MeetingID : null;
   
    useEffect(() => {
        axios({
            method: 'post',
            url: "/api/v1/currentdate",
            headers: { 'referpage': '/meeting/request' }
        })
        .then(
            result => {

                if (_meetingID != null && _meetingID != '') {
                    props.history.push({
                        pathname: '/meeting/request',
                        state: {
                            meetingID: _meetingID
                        }
                    })
                }

            },
            error => {
                props.history.push({
                    pathname: '/auth/login-page',
                    state: {
                        redirect: '/meeting/id/' + _meetingID
                    }
                })
            }
        );  

       


    }, [])

    return (

        <div>

       
        </div>
    );

}





export default Goto;